import { render, staticRenderFns } from "./DataAnalysisManager.vue?vue&type=template&id=0db5b469&scoped=true"
import script from "./DataAnalysisManager.vue?vue&type=script&lang=js"
export * from "./DataAnalysisManager.vue?vue&type=script&lang=js"
import style0 from "./DataAnalysisManager.vue?vue&type=style&index=0&id=0db5b469&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db5b469",
  null
  
)

export default component.exports